import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import Audit from 'components/Inventory/Audit';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <Audit />
      </SiteContent>
    </ContentLayout>
  );
};
